import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { FC, HTMLAttributes } from "react";
import { IntroductionBusinessSectionContent } from "types/graphql/generated";
import { Item } from "./Item";

interface Props {
  className?: HTMLAttributes<HTMLDivElement>["className"];
  content: IntroductionBusinessSectionContent;
}

const BusinessSection: FC<Props> = withErrorBoundary(
  ({
    className = "",
    content: { title, linkOne, linkLabelOne, linkTwo, linkLabelTwo, descriptionOne, descriptionTwo },
  }) => {
    return (
      <div className={className}>
        <h2 className="mb-6 w-max max-w-full rounded-[32px] bg-eucalyptus-80 px-8 py-3 text-xl font-semibold text-eucalyptus-05 xs:text-2xl md:mb-8 lg:mb-10">
          {title}
        </h2>
        <div className="flex flex-col gap-6 md:flex-row">
          <div className="w-50 flex-auto">
            <Item link={linkOne} label={linkLabelOne} description={descriptionOne} />
          </div>
          <div className="w-50 flex-auto">
            <Item link={linkTwo} label={linkLabelTwo} description={descriptionTwo} />
          </div>
        </div>
      </div>
    );
  },
  {}
);

gql`
  fragment IntroductionBusinessSectionContent on ComponentNestedIntroductionBusinessSection {
    title
    linkOne
    linkLabelOne
    linkTwo
    linkLabelTwo
    descriptionOne
    descriptionTwo
  }
`;

export { BusinessSection };
